export const appSelectors = {
  title: (state) => state.title,
  isReady: (state) => state.isReady,
  update: (state) => state.update,
}
